module.exports = __webpack_public_path__ + "static/media/MrSpencerFung.42dd3523.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/comp/sub1/MrSpencerFung.jpg
// module id = 201
// module chunks = 0